import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { buildDefaultPrintSetting } from '../../../../../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../../../../../enums/document-type';
import { openPrintModal } from '../../../../../../../../store/printing/print.actions';
import { ORDER_DETAILS_ACTIONS, useTrackOrderDetailsAction } from '../../../../../event-tracking/use-track-order-details-action';
import { printDocument, downloadDocument } from '../../../../../../../../store/documents/documents.actions';
import PrintDocumentMenuItem from '../../../../../../../../components/print-document-menu-item';
import { useGetPrintSettingsForDocumentType } from '../../../../../../../../hooks/use-get-print-settings-for-document-type';
import { useCanUserPrintOtherForms } from '../../../../../../../../containers/print-document-button-containers/order-details/hooks/use-can-user-print-forms';

const OtherForms = ({ fulfillmentIds, fulfillmentPlanIds }) => {
  const dispatch = useDispatch();
  const canPrintOtherForms = useCanUserPrintOtherForms(fulfillmentPlanIds);
  const printSettings = useGetPrintSettingsForDocumentType(DocumentType.OtherForms.printSettingKey);

  const trackShipmentsOtherFormsClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.SHIPMENTS_PRINT_OTHER_FORMS);

  const onClick = useCallback(() => {
    const url = `${DocumentType.OtherForms.apiDownloadPath}/${fulfillmentIds}`;
    dispatch(openPrintModal(url, DocumentType.OtherForms.identifier, fulfillmentIds));
    trackShipmentsOtherFormsClicks();
  }, [dispatch, fulfillmentIds, trackShipmentsOtherFormsClicks]);

  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.OtherForms, fulfillmentIds));
  }, [dispatch, fulfillmentIds]);

  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.OtherForms, fulfillmentIds, printSettings));
  }, [dispatch, fulfillmentIds, printSettings]);

  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [printSettings, onDownload, onPrint],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={!canPrintOtherForms}
      name={DocumentType.OtherForms.documentNameTranslation}
      onClick={onClick}
    />
  );
};

OtherForms.propTypes = {
  fulfillmentIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default OtherForms;
